import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function resolveEatzyMediaUrl(url: string | undefined | null): string | undefined {
  if (!url) return undefined;
  return url;
}
